import { C15ImageAssetProps } from './C15ImageAsset.types';
import { ImageAssetProps } from '@ahc-digital/component-library';
import { getCheckbox, getDroplink } from 'src/shared/param-utils';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export function CreateImageAssetModel(props?: C15ImageAssetProps): ImageAssetProps {
  const { fields, params } = props || {};
  const { renderRichText, renderLink, renderImage } = useConditionalRendering();

  return {
    isImageBorderOn: getCheckbox(params?.ImageBorderOn),
    imageAlignment: getDroplink(params?.ImageAlignment, 'right'),
    image: renderImage(fields?.Image, { required: true }),
    caption: renderRichText(fields?.Caption),
    imageCTA: renderLink(fields?.ImageCTALink, { editable: false }),
    mobileImage: renderImage(fields?.MobileImage),
  };
}
